<template>
  <div class="od-container" :class="{'px-0': isMobile}" id="support">
    <div class="visual"></div>

    <!-- information -->
    <div class="information" v-show="applyComplete" ref="complete">
      <div class="inwrap">
        <h3>오늘하루치과 모델 지원</h3>

        <p class="text text-center">오늘하루치과 모델 지원이 완료되었습니다.<br />빠른 시일내에 전화드리겠습니다.</p>
      </div>
    </div>
    <!-- e : information -->

    <!-- information -->
    <div class="information" v-show="!applyComplete">
      <div class="inwrap">
        <h3>오늘하루치과 모델 지원</h3>
        <dl>
          <dt>지원 대상</dt>
          <dd>
            <p class="text">건강한 치아를 갖고 있지 않아 환하게 웃을 수 없거나 일상생활에 불편함을 겪고 있는 사람이라면 누구나 지원 가능</p>
            <p class="note">* 의료법상 치료 비용 100% 지원은 진행되지 않는다는 점 참고 바랍니다.</p>
          </dd>
        </dl>
        <dl>
          <dt>선정과정</dt>
          <dd>
            <img v-lazy="`${publicPath}img/counsel/sub_img_02.png`" class="web" alt="">
            <img v-lazy="`${publicPath}img/counsel/sub_img_02_m.png`" class="mobile" alt="">
          </dd>
        </dl>
        <dl class="guide">
          <dt>지원 상세 가이드</dt>
          <dd>
            <p class="text">얼굴 전체와 치아가 선명하게 보이는 셀카 사진 3장 이상 첨부</p>
            <ul class="sample">
              <li><img v-lazy="`${publicPath}img/counsel/02_model_01.jpg`" alt=""><span>예시사진 1</span></li>
              <li><img v-lazy="`${publicPath}img/counsel/02_model_02.jpg`" alt=""><span>예시사진 2</span></li>
              <li><img v-lazy="`${publicPath}img/counsel/02_model_03.jpg`" alt=""><span>예시사진 3</span></li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
    <!-- e : information -->

    <!-- formbox -->
    <div class="formbox" v-show="!applyComplete">
      <div class="inbox">
        <h3 class="h3">초상권 제공 환자 신청하기</h3>
        <ul class="flist">
          <li>
            <label for="model-name" class="label">
              <span>작성자 성함</span>
              <em class="ml-3 text-danger" v-if="errors.has('model-name')">필수 입력 항목입니다.</em>
            </label>
            <input class="fr_input full"
                   type="text" name="model-name"
                   id="model-name"
                   v-model="model.name"
                   placeholder=""
                   ref="model-name"
                   v-validate="'required'">
          </li>
          <li>
            <label for="model-sex" class="label">
              <span>성별</span>
              <em class="ml-3 text-danger" v-if="errors.has('model-sex')">필수 입력 항목입니다.</em>
            </label>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="model-sex-f" name="model-sex" class="custom-control-input" :value="'F'"
                     v-model="model.sex" v-validate="'required'">
              <label class="custom-control-label" for="model-sex-f" style="margin-bottom: 0.5rem;line-height: 1.5rem">여자</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="model-sex-m" name="model-sex" class="custom-control-input" :value="'M'"
                     v-model="model.sex" v-validate="'required'">
              <label class="custom-control-label" for="model-sex-m" style="margin-bottom: 0.5rem;line-height: 1.5rem">남자</label>
            </div>
          </li>
          <li>
            <label for="model-age" class="label">
              <span>나이</span>
              <em class="ml-3 text-danger" v-if="errors.has('model-age')">
                <template v-if="errors.firstRule('model-age') === 'required'">
                  필수 입력항목입니다.
                </template>
                <template v-else-if="errors.firstRule('model-age') === 'numeric'">
                  숫자만 입력하세요.
                </template>
              </em>
            </label>
            <input class="fr_input full"
                   type="text" name="model-age" id="model-age" v-model="model.age"
                   placeholder=""
                   ref="model-age"
                   v-validate="'required|numeric'">
          </li>
          <li>
            <label for="model-contact" class="label">
              <span>연락처</span>
              <em class="ml-3 text-danger" v-if="errors.has('model-contact')">
                <template v-if="errors.firstRule('model-contact') === 'required'">
                  필수 입력항목입니다.
                </template>
                <template v-else-if="errors.firstRule('model-contact') === 'mobile'">
                  잘못된 연락처입니다. (숫자만 입력하세요.)
                </template>
              </em>
            </label>
            <input class="fr_input full"
                   type="text" name="model-contact" id="model-contact" v-model="model.contact"
                   placeholder=""
                   ref="model-contact"
                   v-validate="'required|mobile'">
          </li>
          <li class="message">
            <label for="model-content" class="label">
              <span>상세 내용 및 사연</span>
              <em class="ml-3 text-danger" v-if="errors.has('model-content')">필수 입력 항목입니다.</em>
            </label>
            <vue-editor
              v-model="model.content"
              v-validate="'required'"
              data-vv-name="model-content"
              ref="model-content"
              :useCustomImageHandler="true"
              @image-added="handleImageAdded"
              :editor-options="{ placeholder: placeholder}" />
          </li>
        </ul>

        <!--        <div class="filebox">-->
        <!--          <label for="ex_filename">사진 첨부하기</label>-->
        <!--          <input type="file" id="ex_filename" class="upload-hidden">-->
        <!--          <input class="upload-name" value="" disabled="disabled">-->
        <!--        </div>-->

        <div class="terms_agree">
          <input type="checkbox" id="agree-privacy" name="agree-privacy" v-model="model.agreePrivacy" v-validate="'required'"
                 ref="model-privacy">
          <label for="agree-privacy">개인정보취급방침동의</label>
          <a href="/privacy" class="btn_view" target="_blank" style="margin-bottom: 0.5rem">[자세히보기]</a>
          <em class="ml-3 text-danger" v-if="errors.has('agree-privacy')" style="font-size: 28px;display: block;">필수 동의 항목입니다.</em>
        </div>

        <div class="button_area">
          <input type="button" value="신청하기" class="btn" @click="submit">
          <input type="reset" value="취소" class="btn border" onclick="cancel">
        </div>
      </div>
    </div>
    <!-- e : formbox -->

  </div>
</template>

<script>

import { VueEditor } from 'vue2-editor';

export default {
  name: 'CounselModel',
  components: { VueEditor },
  data() {
    return {
      placeholder: '공정한 선정을 위해 자세히 작성해주세요. \n'
        + '구강 및 안모 사진은 반드시 첨부해주셔야 합니다.',
      applyComplete: false,
      model: {
        name: '',
        age: '',
        sex: '',
        contact: '',
        content: '',
        agreeSms: false,
        agreePrivacy: false,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.model = {
        name: '',
        age: '',
        sex: '',
        contact: '',
        content: '',
        agreeSms: false,
        agreePrivacy: false,
      };
      this.errors.remove();
    },
    cancel() {
      this.init();
    },
    handleImageAdded(file, Editor, cursorLocation) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('dir', 'model');
      formData.append('ext', file.name.split('.').pop());

      this.$axios({
        url: '/api/counsel/apply-model/file',
        method: 'POST',
        data: formData,
      })
        .then((result) => {
          // const { url } = result.data; // Get url from response
          Editor.insertEmbed(cursorLocation, 'image', result.data);
          // resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) {
        const firstField = Object.keys(this.errors.collect())[0];

        // this assumes you have a conviention of ref and field name here I just add the
        // Input suffix to the field name as you can see in the template.
        this.$refs[`${firstField}`].focus();
        this.$refs[`${firstField}`].scrollIntoView();
        return;
      }

      this.$axios.post('/api/counsel/apply-model', this.model)
        .then((res) => {
          console.log(res);
          // eslint-disable-next-line no-alert
          // alert('모델 신청이 완료되었습니다.');
          this.applyComplete = true;
          this.$refs.complete.scrollIntoView();
          this.init();
        })
        .catch((e) => {
          console.log(e);
          // eslint-disable-next-line no-alert
          alert('모델 신청에 실패했습니다.\n잠시 후 다시 시도 부탁드립니다.');
        });
    },
  },
};
</script>

<style scoped>

</style>
